import { render, staticRenderFns } from "./QualityIndexPanel.vue?vue&type=template&id=4bf1447f&scoped=true&"
import script from "./QualityIndexPanel.vue?vue&type=script&lang=js&"
export * from "./QualityIndexPanel.vue?vue&type=script&lang=js&"
import style0 from "./QualityIndexPanel.vue?vue&type=style&index=0&id=4bf1447f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf1447f",
  null
  
)

export default component.exports